export default Object.freeze({
  Process: 1,
  DynamicEntity: 2,
});
